module.exports = __webpack_public_path__ + "img/settingsicon.8f886e47.png";